import { action, makeObservable, observable, computed } from "mobx";
import { computedFn } from "mobx-utils";
import { NavigateFunction } from "react-router-dom";
import { getRoutePath, RoutingParams, Pages } from "routes";
import { UserType } from "types";
import { BaseStore } from ".";
import { Location } from "react-router";


export class RoutingStore implements BaseStore {
  navBarSize:        string | null    = null;
  sidebarContainer:  HTMLElement      = null;
  topbarContainer:   HTMLElement      = null;
  sidebarDrawerOpen: boolean          = true;
  numLoading:        number           = 0;
  showHelpButton:    boolean          = true;
  navigate:          NavigateFunction = null;
  params:            RoutingParams    = null;
  location:          Location         = null;

  private static readonly showHelpButtonStorageKey = "bgi_showHelpButton";

  public static readonly loginPage = process.env.NODE_ENV === 'production' ? Pages.BankID : Pages.AdminLogin;
  public static readonly startPage: Record<UserType, Pages> = {
    [UserType.Admin]:       Pages.Customers,
    [UserType.Analyst]:     Pages.Statistics,
    [UserType.Participant]: Pages.Library,
    [UserType.Manager]:     Pages.Library,
    [UserType.Editor]:      Pages.Courses,
  };

  constructor() {
    makeObservable(this, {
      setNavBarHeight:      action,
      setSidebarContainer:  action,
      setTopbarContainer:   action,
      openSidebarDrawer:    action,
      startLoading:         action,
      finishLoading:        action,
      toogleShowHelpButton: action,
      push:                 action,
      setNavigate:          action,
      goBack:               action,
      setParams:            action,
      setLocation:          action,

      numLoading:        observable,
      navBarSize:        observable,
      sidebarContainer:  observable,
      topbarContainer:   observable,
      sidebarDrawerOpen: observable,
      showHelpButton:    observable,
      params:            observable,
      location:          observable,

      isLoading:             computed,
      getCustomerShowNested: computed,

    });

    // Load showHelpButton from session storage
    this.showHelpButton = Boolean(window.sessionStorage.getItem(RoutingStore.showHelpButtonStorageKey));
  }

  setNavigate(navigate: NavigateFunction) {
    this.navigate = navigate;
  }

  push(page: Pages, params?: RoutingParams) {
    if(!this.navigate) return;

    this.navigate(getRoutePath(page, params));
  }

  goBack() {
    if(!this.navigate) return;

    this.navigate(-1);
  }

  init() {
    // init
  }

  clear = () => {
    // clear
  };
  setNavBarHeight = (height: string) => {
    this.navBarSize = height;
  };

  setSidebarContainer = (el: HTMLElement) => {
    this.sidebarContainer = el;
  }

  setTopbarContainer = (el: HTMLElement) => {
    this.topbarContainer = el;
  }

  openSidebarDrawer = (open: boolean) => {
    this.sidebarDrawerOpen = open;
  }

  startLoading = () => {
    this.numLoading++;
  }

  finishLoading = () => {
    this.numLoading--;
  }

  /**
   * Overwrite this to return true if you want to force the loading screens to appear.
   */
  get isLoading() {
    return this.numLoading > 0;
  }

  toogleShowHelpButton = () => {
    if(this.showHelpButton)
      window.sessionStorage.removeItem(RoutingStore.showHelpButtonStorageKey);
    else 
      window.sessionStorage.setItem(RoutingStore.showHelpButtonStorageKey, "1");
    this.showHelpButton = !this.showHelpButton;
  }

  getCustomerRoutingParams = computedFn((subview: 'users' | 'programs' | 'courses'): RoutingParams => {
    return {
      id: this.params?.id,
      view: subview,
    }
  });

  get getCustomerShowNested(): boolean {
    return this.location.pathname.split("/")[1] === Pages.Customers && Boolean(this.params?.id);
  }

  setParams = (params: RoutingParams): void => {
    this.params = params;
  }

  setLocation = (location: Location): void => {
    this.location = location;
  }
}
